import { useContext } from 'react';
import { UserLocationContext } from '@honda-canada/user-location';
import camelcaseKeys from 'camelcase-keys';
import { apiModes } from '../../../utils/constants';
import getProductLineLetter from '../../../utils/api/getProductLineLetter';
import { useApiHost, useAppName, useLanguage, usePageState, useSettings } from '../../../utils/sitecoreContext';
import { useCurrentProductLine } from '../../SelectProductsContext/SelectProductsProvider';
import useFetchData from '../../../hooks/useFetchData';

const fetchOptions = { method: 'GET' };

const useAccessoriesFetch = ({ transmissionId, formatter }) => {
  const provinceCode = useContext(UserLocationContext)?.provinceCode;
  const [currentProductLine] = useCurrentProductLine();

  const appName = useAppName();
  const hondaRestApiHost = useApiHost();
  const language = useLanguage();
  const pageState = usePageState();
  const apiMode = apiModes[pageState] || 'Live';
  const { defaultProvince } = useSettings();

  const productLineLetter = getProductLineLetter.get(currentProductLine) || getProductLineLetter.get(appName);
  const apiPath = `models/${productLineLetter}/${apiMode}/transmissions/accessories/search/?transmissionIds=${transmissionId}&province=${
    provinceCode || defaultProvince
  }&AcceptLanguage=${language}`;
  const apiUrl = transmissionId ? `https://${hondaRestApiHost}/${apiPath}` : '';

  const { data, isLoading, error } = useFetchData(apiUrl, fetchOptions);
  const accessories = camelcaseKeys(data, { deep: true });

  return {
    accessories: formatter && accessories ? formatter(accessories) : accessories,
    accessoriesLength: accessories?.length,
    isFetching: isLoading,
    hasError: !!error,
  };
};

export default useAccessoriesFetch;
